import {Controller} from 'stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['item']

  connect () {
    this.markAddedBooks()
  }

  markAddedBooks () {
    const addedTitles = this.bookDamageSubmissionController.getAddedTitles()

    this.itemTargets.forEach(item => {
      if (addedTitles.includes(item.dataset.title)) {
        const addBtn = item.querySelector('[data-action*="add"]')
        const checkBtn = addBtn?.nextElementSibling
        if (addBtn) addBtn.classList.add('d-none')
        if (checkBtn) checkBtn.classList.remove('d-none')
      }
    })
  }

  search (event) {
    event.preventDefault()

    const action = event.target.action
    const query = $(event.target).serialize()

    this.load(`${action}?${query}`)
  }

  paginate (event) {
    event.preventDefault()

    const link = event.target.closest('a')
    if (link == null) return

    this.load(link.href)
  }

  async load (url) {
    const response = await fetch(url)
    const html = await response.text()

    this.element.closest('.modal').scrollTop = 0

    const $elem = $(html).find('[data-controller~=book-damage-select-book]')
    $(this.element).replaceWith($elem)
  }

  add (event) {
    const item = event.target.closest('[data-target="book-damage-select-book.item"]')
    const { title, subject, grade } = item.dataset

    this.bookDamageSubmissionController.add({ title, subject, grade })

    event.currentTarget.classList.add('d-none')
    event.currentTarget.nextElementSibling.classList.remove('d-none')
  }

  get bookDamageSubmissionController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === 'book-damage-submission'
    })
  }
}
